@if(displaySkipIntro()){
<button class="skip-intro" (click)="skipIntro()">{{ 'vod.buttons.skip_intro' | transloco }}</button>
}
